import styled from '@emotion/styled';
import theme from '@travelnest/merlin.theme';
import * as React from 'react';

interface IScoreInformWrapperProps {
	backgroundColor: string;
	color: string;
}

const ScoreInformWrapper = styled.div<IScoreInformWrapperProps>`
	height: 100%;
	max-width: 66%;
	background-color: ${(props) => props.backgroundColor};
	color: ${(props) => props.color};
	border-radius: ${theme.layout.radius.default};

	button {
		font-size: 13px;
		height: 33px;
		width: 109px;
	}

	@media only screen and (max-width: 768px) {
		max-width: 400px;
	}
`;

interface IScoreInformProps {
	backgroundColor: string;
	color: string;
	children?: string | React.ReactNode;
}

export const ScoreInform: React.FC<IScoreInformProps> = ({ backgroundColor, color, children }) => {
	return (
		<ScoreInformWrapper
			className="score-inform"
			backgroundColor={backgroundColor}
			color={color}
		>
			{children}
		</ScoreInformWrapper>
	);
};
